import React from 'react';

import { BackArrowLink as BaseBackArrow } from 'components/navigation/back-arrow';
import { routes } from 'utils/routing';

const BackArrow = () => <BaseBackArrow to={routes.base} />;

export { BackArrow };
